import React, { createContext, useContext, useMemo, useState } from 'react';

import { HoveredStationContext as Context } from './types';

const HoveredStationContext = createContext({} as Context);
export const useHoveredStationContext = () => useContext(HoveredStationContext);

export const HoveredStationProvider = ({ children }: { children?: React.ReactNode; }) => {
  const [ hoveredStation, setHoveredStation ] = useState<Context['hoveredStation']>(null);

  const value = useMemo(() => ({
    hoveredStation,
    setHoveredStation
  }), [
    hoveredStation,
    setHoveredStation
  ]);

  return (
    <HoveredStationContext.Provider value={value}>{children}</HoveredStationContext.Provider>
  );
};
